import { render, staticRenderFns } from "./ChatBotMessages.vue?vue&type=template&id=8f8f31ea&scoped=true&"
import script from "./ChatBotMessages.vue?vue&type=script&lang=js&"
export * from "./ChatBotMessages.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotMessages.vue?vue&type=style&index=0&id=8f8f31ea&lang=scss&scoped=true&"
import style1 from "./ChatBotMessages.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8f31ea",
  null
  
)

export default component.exports